import { questionSetStore } from "./question-set-store";

export type { QuestionnaireDefinitionDto as PerformanceMeasureDefinitionDto } from "./question-set-store";
export const {
  projectQuestionnaireDefinition: projectPerformanceMeasureDefinition,
  useQuestionnaireDefinitions: usePerformanceMeasureDefinitions,
  useQuestionnaireDefinition: usePerformanceMeasureDefinition,
  defineQuestionnaireDefinition: definePerformanceMeasureDefinition,
  reviseQuestionnaireDefinition: revisePerformanceMeasureDefinition,
  correctQuestionnaireDefinition: correctPerformanceMeasureDefinition,
  activateQuestionnaireDefinition: activatePerformanceMeasureDefinition,
  deactivateQuestionnaireDefinition: deactivatePerformanceMeasureDefinition,
} = questionSetStore(true);
